// extracted by mini-css-extract-plugin
export default {"icon":"RecentSignal_icon__ptsf6"};